/**
 * Align Shopify Markets country with the active storefront language.
 * Unique languages map 1:1 ( /pl → PL ). Shared languages keep the current
 * country when it is valid for that language ( /fr + LU stays Luxembourg ).
 */
(() => {
  const LOCALE_COUNTRIES = {
    de: ['DE', 'AT'],
    fr: ['FR', 'LU', 'BE'],
    nl: ['NL', 'BE'],
    da: ['DK'],
    pl: ['PL'],
    cs: ['CZ'],
    sk: ['SK'],
    es: ['ES'],
  };

  const lang = document.documentElement.lang?.split('-')[0]?.toLowerCase();
  const allowed = LOCALE_COUNTRIES[lang];
  if (!allowed?.length) return;

  const root = document.querySelector('[data-localization-selectors]');
  if (!root) return;

  const countrySelect = root.querySelector('select[name="country_code"]');
  if (!countrySelect) return;

  const current = countrySelect.value;
  if (allowed.includes(current)) return;

  const want = allowed[0];
  const hasOption = [...countrySelect.options].some((option) => option.value === want);
  if (!hasOption) return;

  countrySelect.value = want;
  countrySelect.closest('form')?.requestSubmit();
})();
